import { caseTaskSchema } from "@/components/Forms/schema/addCaseTasksSchema.ts";
import { dtMetaSchema } from "@/components/Forms/schema/dtMetaSchema.ts";
import { mrtCaseSchema } from "@/components/Forms/schema/mrtCaseSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createDataSelector, createResourceCollectionSelector } from "jsonapi-zod-query";

export const resourceSelector = createResourceCollectionSelector({
    type: "caseTask",
    attributesSchema: caseTaskSchema,
    documentMetaSchema: dtMetaSchema,
    relationships: {
        case: {
            relationshipType: "one",
            include: {
                type: "case",
                attributesSchema: mrtCaseSchema,
            },
        },
    },
});

export const caseTasksSelector = createDataSelector(resourceSelector);
export type CaseTasksPendingDocument = ReturnType<typeof caseTasksSelector>;
export type CaseTaskPending = CaseTasksPendingDocument[number];

export const useFetchCaseTasksPending = (): UseQueryResult<CaseTasksPendingDocument> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        queryKey: ["case-tasks-pending"],
        queryFn: async () => {
            const response = await fetch(apiUrl("/case-task/pending"), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            return await response.json();
        },
        select: caseTasksSelector,
    });
};
